import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingProvider: false,
  isFetchingHEDIS: false,
  isFetchingLastRun: false,

  result: [],
};

const eligibilityGAPReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PROVIDER_GAP_REPORT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingProvider: true,
      };

    case types.GET_PROVIDER_GAP_REPORT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingProvider: false,
      };

    case types.GET_PROVIDER_GAP_REPORT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingProvider: false,
      };

    case types.GET_PROVIDER_HEDIS_GAP_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingHEDIS: true,
      };

    case types.GET_PROVIDER_HEDIS_GAP_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingHEDIS: false,
      };

    case types.GET_PROVIDER_HEDIS_GAP_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingHEDIS: false,
      };

    case types.GET_LAST_RUN_GAP_DATE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingLastRun: true,
      };

    case types.GET_LAST_RUN_GAP_DATE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingLastRun: false,
      };

    case types.GET_LAST_RUN_GAP_DATE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingLastRun: false,
      };

    case types.DOWNLOAD_DOCUMENT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingLastRun: true,
      };

    case types.DOWNLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingLastRun: false,
      };

    case types.DOWNLOAD_DOCUMENT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingLastRun: false,
      };

    default:
      return state;
  }
};

export default eligibilityGAPReducer;
